import { ErrorResponse, onError } from "apollo-link-error";
import { GraphQLError } from "graphql";

import { notify } from "../../toaster";

export const errorLink = onError((error: ErrorResponse) => {
  if (error.graphQLErrors && !error.networkError) {
    error.graphQLErrors.forEach((graphQLError: GraphQLError) => {
      if (graphQLError.code === 402) {
        notify(graphQLError.subError.message);
      }

      return null;
    });
  }
});
